import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j8jk2k8849: FaireBrandEntity = {
  token: "b_j8jk2k8849",
  type: "brand",
  name: "ILISSA MICHELE JEWELRY",
  avatarUrl:
    "https://cdn.faire.com/fastly/7b52f0c60760f9ee6db514e59a7e6a1d450345c0e526e795de21f93faccd55be.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7769b66948ef033cd909964da9fc2d4713a8f81c601752ecde9571f79d6984cc.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7b52f0c60760f9ee6db514e59a7e6a1d450345c0e526e795de21f93faccd55be.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7769b66948ef033cd909964da9fc2d4713a8f81c601752ecde9571f79d6984cc.jpeg",
  location: "East Hampton, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 12,
  isInsider: true,
  description:
    "Crafting has always been apart of my life. Wether it was pottery, knitting, crocheting, or jewelry making I have always been driven to the arts. When my kids were born raising my family became my first priority. But after they moved out I found my passion again.\n\nHaving more time on my hands allowed me a lot of time to think as well as do what I love. For me jewelry is a way to make a statement that reflects who you are. My belief is that even with just a simple white t-shirt, a necklace can make the outfit. The mission of my company is for people to be inspired by my pieces, the way others have inspired me.\n\nThe most fitting story for my company is how my first piece got sold. I was on an airplane wearing one of my necklaces. The woman in the seat next to me turned and asked me where she could buy one like mine. After telling her it was handmade she asked if she could buy it. I sold my first necklace off of my neck and that was the start of Ilissa Michele Jewelry.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:16.541Z",
    importedBy: "entity-db-cli",
  },
};
